import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { HiListBullet, HiCalendarDays } from 'react-icons/hi2';
import { PageContent, PageHeader } from '@/components/layout/PageLayout';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import KanbanBoard from '@/components/sprawy/KanbanBoard';
import SprawaDetailModal from '@/components/sprawy/SprawaDetailModal';
import { useListSprawyQuery, useListSprawaStatusDefinitionsQuery } from '@/store/sprawyApi';

export default function SprawyBoardPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedSprawaId, setSelectedSprawaId] = useState<string | null>(null);

  const { data: sprawyData, isLoading: sprawyLoading } = useListSprawyQuery({ pageSize: 200 });
  const { data: statusDefinitions, isLoading: defsLoading } = useListSprawaStatusDefinitionsQuery();

  const isLoading = sprawyLoading || defsLoading;

  return (
    <PageContent>
      <PageHeader
        title={t('sprawy.board.title')}
        subtitle={t('sprawy.subtitle')}
        actions={
          <>
            <Button variant="outline-primary" onClick={() => navigate('/sprawy')}>
              <HiListBullet size="1rem" className="me-2" />
              {t('sprawy.board.switchToList')}
            </Button>
            <Button variant="outline-primary" onClick={() => navigate('/sprawy/calendar')}>
              <HiCalendarDays size="1rem" className="me-2" />
              {t('calendar.switchToCalendar')}
            </Button>
          </>
        }
      />

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <KanbanBoard
          sprawy={sprawyData?.items ?? []}
          statusDefinitions={statusDefinitions ?? []}
          onCardClick={(id) => setSelectedSprawaId(id)}
        />
      )}

      <SprawaDetailModal
        sprawaId={selectedSprawaId}
        onClose={() => setSelectedSprawaId(null)}
      />
    </PageContent>
  );
}
